import { useState, useEffect } from 'react'
import { NavLink, useSearchParams } from 'react-router-dom'
import { Grid, Input, Card, List, Tooltip } from '@design-systems/canvas-ui'
import Icon, {
  ProfileIcon,
  StoreIcon,
  InfoIcon,
} from '@design-systems/react-icons'
import VettingSummaryTable from './VettingSummaryTable'
import {
  RFI_TYPE_SUPPLIER,
  RFI_TYPE_LOCATION,
  PARAM_TYPE,
  ADMIN_ID_CHATBOT_LCM,
  ADMIN_CONTROL_TYPE,
} from '../../common/commonConstants'
import { getRfiTagValues } from '../../common/common'
import { userInfoData } from '../../views/Main'
import fireflyData from '../../common/fireflyData'
import { useAnalytics } from '@praxis/analytics/client'
import ChatBotWidget from '../Chatbot/ChatBotWidget'
import { getControlVisibility } from '../../common'
import { createFireflyEvent } from '../../common/helper'

const vettingLandingMenu = [
  {
    option: 'Supplier Vetting',
    icon: ProfileIcon,
    type: RFI_TYPE_SUPPLIER,
  },
  {
    option: 'Location Vetting',
    icon: StoreIcon,
    type: RFI_TYPE_LOCATION,
  },
]

const VettingSummaryLanding = (props) => {
  const { sendEvent } = useAnalytics()
  const [searchParams] = useSearchParams()
  const [selectedVetting, setSelectedVetting] = useState('')
  let vettingType = searchParams.get(PARAM_TYPE)

  //Aproval Summary
  const [isGetApprovalInProgress, setIsGetApprovalInProgress] = useState(false)
  const [isGetApprovalFailed, setIsGetApprovalFailed] = useState(false)
  const [isGetApprovalSuccess, setIsGetApprovalSuccess] = useState(false)

  //#region UseEffect

  useEffect(() => {
    setSelectedVetting(
      vettingType && vettingType.toLowerCase() === RFI_TYPE_LOCATION
        ? RFI_TYPE_LOCATION
        : RFI_TYPE_SUPPLIER,
    )
    if (userInfoData) {
      sendEvent(
        createFireflyEvent('selected_mfe', 'LCM MFE INTERNAL', userInfoData),
      )
    }
  }, [vettingType, sendEvent])

  //#endregion

  /**
   * Build the RFI Approval Summary left menu
   * @returns
   */
  const buildMenu = () => {
    let menuOptions = vettingLandingMenu.map((eachOption, optionIndex) => {
      return (
        <List.Item
          key={`sidenav-li-${optionIndex}`}
          id={`sidenav-li-${optionIndex}`}
          isSelected={selectedVetting === eachOption.type}
          as={NavLink}
          to={`/internal/vetting_summary?type=${eachOption.type}`}
        >
          <div className="align-centre-left">
            <Icon svg={eachOption.icon} className="hc8-mr-2x" aria-hidden />
            {eachOption.option}
          </div>
        </List.Item>
      )
    })

    return (
      <>
        <Card
          variant="default"
          className="hc8-ph-2x hc8-pt-6x"
          data-testid="card-vetting-landing-left-menu"
        >
          <Input.Label className="hc8-fs-100 font-weight-500">
            Vetting Approval
          </Input.Label>
        </Card>
        <List
          className="hc8-mt-3x cursor-pointer"
          id="list-vetting-landing-menu"
        >
          {menuOptions}
        </List>
      </>
    )
  }

  return (
    <Grid.Container
      spacing="none"
      id="grid-vetting-summary-landing"
      data-testid="grid-vetting-summary-landing"
      className="vetting-summary-layout"
    >
      {props.showSideNav && (
        <Grid.Item
          size={{ xs: 2 }}
          id="sideNav"
          className="hc8-pl-3x vetting-summary-sidebar"
        >
          {buildMenu()}
          {getControlVisibility(
            ADMIN_ID_CHATBOT_LCM,
            ADMIN_CONTROL_TYPE,
            props.userSettings,
          ) && <ChatBotWidget />}
        </Grid.Item>
      )}

      {/* 1. In progress */}
      {/* 2. Display table */}
      <Grid.Item
        data-testid="gi-vetting-list"
        id="gi-vetting-list"
        size={{ xs: props.showSideNav ? 10 : 12 }}
        className="hc8-pa-3x vetting-summary-main"
      >
        <div>
          <Card variant="elevated" className="align-centre-left hc8-mb-2x">
            <Input.Label className="hc8-fs-150 hc8-pa-6x hc8-ma-none font-weight-500">
              Vetting Approval
            </Input.Label>
            <Tooltip
              content={getRfiTagValues('vetting')['vettingApprovalInstruction']}
              location="right"
            >
              <Icon
                className="row-centre"
                svg={InfoIcon}
                aria-label="Vetting approval information"
              />
            </Tooltip>
          </Card>
          <Card variant="elevated" className="align-centre-left hc8-mb-2x">
            <VettingSummaryTable
              vettingType={selectedVetting}
              isGetApprovalInProgress={isGetApprovalInProgress}
              isGetApprovalFailed={isGetApprovalFailed}
              setIsGetApprovalInProgress={setIsGetApprovalInProgress}
              setIsGetApprovalFailed={setIsGetApprovalFailed}
              isGetApprovalSuccess={isGetApprovalSuccess}
              setIsGetApprovalSuccess={setIsGetApprovalSuccess}
            />
          </Card>
        </div>
      </Grid.Item>
    </Grid.Container>
  )
}

export default VettingSummaryLanding
